import React, { useEffect, useState } from "react";
import appStyles from "../../app.module.css";
import Api from "../classes/api";
import AppConstants from "../classes/constants";
import AppUtil from "../classes/util";
import AddEditExtraFee from "./add-edit-extra-fee/add-edit-extra-fee";

const ExtraFees = () => {
	const [extraFees, setExtraFees] = useState([]);
	const [selectedExtraFee, setSelectedExtraFee] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		setError(null);
	}, [selectedExtraFee]);

	useEffect(() => {
		loadExtraFees();
	}, []);

	const loadExtraFees = async () => {
		try {
			setError(null);
			const formData = new FormData();
			formData.append("action", "rsquote_extra_fee");
			formData.append("method", AppConstants.WP_METHOD.LIST);
			const apiSvc = await Api.getInstance();
			const res = await apiSvc.getData(formData);
			setExtraFees(res.data?.data?.length ? res.data.data : []);
		} catch (err) {
			setError(AppUtil.getErrorMessage(err));
		}
	};

	const handleClose = () => {
		setSelectedExtraFee(null);
	};

	const handleSubmit = async (values) => {
		try {
			setError(null);
			const formData = new FormData();
			if (selectedExtraFee?.id) {
				formData.append("id", selectedExtraFee.id);
			}
			formData.append("buyer_disbursment", values.buyer_disbursment || 0);
			formData.append(
				"seller_disbursment",
				values.seller_disbursment || 0
			);
			formData.append("govt_enquiry_fee", values.govt_enquiry_fee || 0);
			formData.append(
				"electronic_conveyancing_fee",
				values.electronic_conveyancing_fee || 0
			);
			formData.append(
				"verification_identity_fee",
				values.verification_identity_fee || 0
			);
			formData.append(
				"strata_titles_act_sec_110_certificate",
				values.strata_titles_act_sec_110_certificate || 0
			);
			formData.append(
				"landgate_discharge_of_mortgage",
				values.landgate_discharge_of_mortgage || 0
			);
			formData.append(
				"apr_or_sa_per_application",
				values.apr_or_sa_per_application || 0
			);
			formData.append(
				"inperson_settlement_attendance",
				values.inperson_settlement_attendance || 0
			);
			formData.append(
				"privacy_compliance_fee",
				values.privacy_compliance_fee || 0
			);
			formData.append("action", "rsquote_extra_fee");
			formData.append(
				"method",
				selectedExtraFee?.id
					? AppConstants.WP_METHOD.EDIT
					: AppConstants.WP_METHOD.NEW
			);
			const apiSvc = await Api.getInstance();
			const res = await apiSvc.addEditDeleteRequest(formData);
			if (res?.data?.success) {
				setSelectedExtraFee(null);
				loadExtraFees();
			} else {
				setError(AppUtil.getErrorMessage(res));
			}
		} catch (err) {
			setError(AppUtil.getErrorMessage(err));
		}
	};

	return (
		<div className={appStyles.rezziBlock}>
			<div className={appStyles.rezziBlockHeader}>
				<h2 className={appStyles.colorPrimary}> Extra Fees </h2>
				{/* <button onClick={() => setSelectedExtraFee({})}>Add New</button> */}
			</div>
			{!selectedExtraFee && error && (
				<div className={appStyles.colorDanger}>{error}</div>
			)}
			<div className={appStyles.rezziBlockHeaderTable}>
				<table width="100%" cellPadding={0} cellSpacing={0}>
					<thead>
						<tr>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Buyer Disbursment (est, 3 searches, 38.50/search)
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Seller Disbursment (est, 3 searches, $38.50/search)
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Govt. Enquiry Fee
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Electronic Conveyancing Fee
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Verification of Identity fee (per person)
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Strata Titles Act Sec 110 Certificate
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Landgate Discharge of Mortgage
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								APR or SA (Per Application)
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Inperson Settlement Attendance
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							>
								Privacy Compliance Fee
							</th>
							<th
								className={`${appStyles.colorPrimary} ${appStyles.textLeft}`}
							></th>
						</tr>
					</thead>
					<tbody>
						{extraFees?.length
							? extraFees.map((extrafee) => {
									return (
										<tr key={extrafee.id}>
											<td>
												{parseFloat(
													extrafee.buyer_disbursment
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.seller_disbursment
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.govt_enquiry_fee
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.electronic_conveyancing_fee
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.verification_identity_fee
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.strata_titles_act_sec_110_certificate
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.landgate_discharge_of_mortgage
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.apr_or_sa_per_application
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.inperson_settlement_attendance
												).toFixed(2)}
											</td>
											<td>
												{parseFloat(
													extrafee.privacy_compliance_fee
												).toFixed(2)}
											</td>
											<td className={appStyles.textRight}>
												<button
													onClick={() =>
														setSelectedExtraFee(
															extrafee
														)
													}
												>
													Edit
												</button>
											</td>
										</tr>
									);
							  })
							: null}
					</tbody>
				</table>
			</div>
			{selectedExtraFee && (
				<AddEditExtraFee
					extraFee={selectedExtraFee}
					submit={handleSubmit}
					close={handleClose}
					error={error}
				/>
			)}
		</div>
	);
};

export default ExtraFees;
